/* eslint-disable camelcase */
import Robodog from '@uppy/robodog';
import {extractElement} from 'extensions/extract-element';
import {defineCustomElement} from 'extensions/ui-utils';
import {html, LitElement} from 'lit';
import stylesheet from './x-file-uploader.scss?as=stylesheet';

const transloaditParams 	= extractElement('#tli_policy');
const transloaditSignature 	= extractElement('#tli_sig');
const transloaditTemplateID = extractElement('#tli_templateid');

export class FileUploader extends LitElement {
	static get styles () {
		return [stylesheet];
	}

	static get properties () {
		return {
			label: {
				type: String
			}
		};
	}

	constructor () {
		super();

		/**
		 * @type {string}
		 */
		this.label = 'Upload File(s)';
	}

	async handleButtonClick () {
		const bundle = await Robodog.pick({
			closeModalOnClickOutside: true,
			params: transloaditParams,
			providers: [
				'webcam',
				'url',
				'dropbox'
			],
			signature: transloaditSignature,
			template_id: transloaditTemplateID,
			waitForEncoding: true
		});

		const successfulUploads = bundle.results?.filter(result => result.stepName === 'viruscheck') || [];

		// Dispatch change if successful
		if (successfulUploads && successfulUploads.length > 0) {
			this.dispatchEvent(new CustomEvent('change', {
				bubbles: true,
				composed: true,
				detail: successfulUploads.map(successfulUpload => ({
					name: successfulUpload.original_name,
					url: successfulUpload.ssl_url
				}))
			}));
		}
	}

	render () {
		return html`
			<button class="button" @click="${this.handleButtonClick}">
				<span class="icon"></span>
				${this.label}
			</button>
		`;
	}
};

defineCustomElement('x-file-uploader', FileUploader);
